import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Modal } from "../modal/Modal";
import { Button } from "../input/Button";
import { ReactComponent as EnterIcon } from "../icons/Enter.svg";
import { ReactComponent as VRIcon } from "../icons/VR.svg";
import { ReactComponent as ShowIcon } from "../icons/Show.svg";
import { ReactComponent as SettingsIcon } from "../icons/Settings.svg";
import styles from "./RoomEntryModal.scss";
import styleUtils from "../styles/style-utils.scss";
import { useCssBreakpoints } from "react-use-css-breakpoints";
import { Column } from "../layout/Column";
import { AppLogo } from "../misc/AppLogo";
import { FormattedMessage, useIntl } from "react-intl";

const isSafariOnIphoneIpad = function () {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;
  let platform = navigator.platform;
  if (
    (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) ||
    (platform === "MacIntel" &&
      userAgent.includes("Safari") &&
      !userAgent.includes("Chrome") &&
      navigator.maxTouchPoints > 1)
  ) {
    // Access from iPhone Safari, iPad Safari (including Desktop mode)
    return true;
  } else {
    // Access from other devices or browsers
    return false;
  }
};

export function RoomEntryModal({
  className,
  roomName,
  customLogo,
  showJoinRoom,
  onJoinRoom,
  showEnterOnDevice,
  onEnterOnDevice,
  showSpectate,
  onSpectate,
  showOptions,
  onOptions,
  ...rest
}) {
  const breakpoint = useCssBreakpoints();
  const [message, setMessage] = useState(isSafariOnIphoneIpad());
  const intl = useIntl();
  const ms = intl.formatMessage(
    {
      id: "room-entry-modal.safari_ios_message",
      defaultMessage:
        "When using the browser [Safari] installed on the iPhone, the following functions cannot be used due to restrictions in the specifications if pop-up blockers are set.{br}・Links from objects in the room to web pages, etc.{br}{br}Please follow the steps below to turn off the pop-up blocker.{br}Settings > safari > Cancel pop-up blocker{br}*When you tap the link, a pop-up window will appear. Tap Allow to open the link destination in a separate window."
    },
    { br: <br /> }
  );
  return (
    <>
      {message && (
        <div className={classNames(styles.customMessageBox)}>
          <button
            type="button"
            onClick={() => {
              setMessage(false);
            }}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          {ms}
        </div>
      )}
      <Modal className={classNames(styles.roomEntryModal, className)} disableFullscreen {...rest}>
        <Column center className={styles.content}>
          {breakpoint !== "sm" && breakpoint !== "md" && (
            <div className={styles.logoContainer}>{customLogo ? <AppLogo customLogo={customLogo} /> : <AppLogo />}</div>
          )}
          <div className={styles.roomName}>
            <h5>
              <FormattedMessage id="room-entry-modal.room-name-label" defaultMessage="Room Name" />
            </h5>
            <p>{roomName}</p>
          </div>
          <Column center className={styles.buttons}>
            {showJoinRoom && (
              <Button preset="accent4" onClick={onJoinRoom}>
                <EnterIcon />
                <span>
                  <FormattedMessage id="room-entry-modal.join-room-button" defaultMessage="Join Room" />
                </span>
              </Button>
            )}
            {showEnterOnDevice && (
              <Button preset="accent5" onClick={onEnterOnDevice}>
                <VRIcon />
                <span>
                  <FormattedMessage id="room-entry-modal.enter-on-device-button" defaultMessage="Enter On Device" />
                </span>
              </Button>
            )}
            {showSpectate && (
              <Button preset="accent2" onClick={onSpectate}>
                <ShowIcon />
                <span>
                  <FormattedMessage id="room-entry-modal.spectate-button" defaultMessage="Spectate" />
                </span>
              </Button>
            )}
            {showOptions && breakpoint !== "sm" && (
              <>
                <hr className={styleUtils.showLg} />
                <Button
                  preset="transparent"
                  className={classNames(styleUtils.showLg, styleUtils.blackButton)}
                  onClick={onOptions}
                >
                  <SettingsIcon />
                  <span>
                    <FormattedMessage id="room-entry-modal.options-button" defaultMessage="Options" />
                  </span>
                </Button>
              </>
            )}
            <div className={styles.copyright}>
              <FormattedMessage id="room-entry-modal.copyright" defaultMessage="Powered by おりこうブログCX" />
            </div>
          </Column>
        </Column>
      </Modal>
      {/* <Modal className={classNames(styles.roomEntryModal, className)} disableFullscreen {...rest}>
        <Column center className={styles.content}>
          ABCDE
        </Column>
      </Modal> */}
    </>
  );
}

RoomEntryModal.propTypes = {
  className: PropTypes.string,
  roomName: PropTypes.string.isRequired,
  showJoinRoom: PropTypes.bool,
  onJoinRoom: PropTypes.func,
  showEnterOnDevice: PropTypes.bool,
  onEnterOnDevice: PropTypes.func,
  showSpectate: PropTypes.bool,
  onSpectate: PropTypes.func,
  showOptions: PropTypes.bool,
  onOptions: PropTypes.func
};

RoomEntryModal.defaultProps = {
  showJoinRoom: true,
  showEnterOnDevice: true,
  showSpectate: true,
  showOptions: true
};
